import React, { ReactNode } from "react";
import { BoxSubTitle, BoxTitle } from "./boxTitle.style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";

export default (props: {
  title?: React.ReactNode;
  subtitle?: string;
  icon?: IconProp;
  inner?: boolean;
  plain?: boolean;
  middle?: boolean;
  underline?: boolean;
  extra?: ReactNode;
}) => (
  <div
    className={classNames(
      "w-full flex content-center flex-col justify-evenly text-[var(--primary)] [&_.fa-lg]:scale-[1.18]",
      { "rounded-none": props.inner }
    )}
  >
    {!props.plain && props.middle && (
      <div className="ml-[55px] w-[calc(100%-55px-55px)] border-b border-[#ebebeb]" />
    )}

    <div className="pt-[var(--gap-medium)] flex items-center">
      {props.icon && <FontAwesomeIcon className="ml-5 text-[var(--primary)]" icon={props.icon} size={"lg"} />}

      {props.title ? <BoxTitle className="isoBoxTitle"> {props.title} </BoxTitle> : ""}
      {props.subtitle ? <BoxSubTitle className="isoBoxSubTitle"> {props.subtitle} </BoxSubTitle> : ""}
      {props.extra}
    </div>
    {props.underline && <div className="ml-[55px] w-[calc(100%-55px-55px)] border-b border-[#ebebeb]" />}
  </div>
);
